import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AdditionalFilesUploadRequest, AdditionalInfo } from '@models/additional-info.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdditionalInfoService {
  private readonly http = inject(HttpClient);
  public readonly additionalInfo = {
    check$: this.http.get<AdditionalInfo>('additional-file-request/check')
  };

  public uploadAdditionalFiles(request: FormData): Observable<any> {
    return this.http.post<any>('additional-file-upload', request, {
      params: { notEncrypt: true }
    });
  }
  public isIdExpired = false;
}
